export const DEFAULT_RAYON_COLOR = '#0d9488';

export const RAYON_COLOR_PALETTE = [
  '#0d9488',
  '#2563eb',
  '#f97316',
  '#9333ea',
  '#db2777',
  '#0891b2',
  '#ca8a04',
  '#475569',
];

const HEX_COLOR_RE = /^#[0-9a-f]{6}$/i;

export const normalizeRayonColor = (value?: string | null): string => {
  const color = String(value || '').trim();

  return HEX_COLOR_RE.test(color) ? color.toLowerCase() : DEFAULT_RAYON_COLOR;
};

export const colorToPickerValue = (value?: string | null): string => {
  return normalizeRayonColor(value).replace('#', '');
};

export const pickerValueToColor = (value?: string | null): string => {
  const color = String(value || '').trim().replace(/^#/, '');

  return normalizeRayonColor(`#${color}`);
};

export const rayonAccentStyle = (value?: string | null): Record<string, string> => {
  const color = normalizeRayonColor(value);

  return {
    '--rayon-color': color,
    '--rayon-color-soft': `${color}1f`,
  };
};
